gsap.registerPlugin(ScrollTrigger);
// ==================================================================================== SECTION 1
gsap.set('.co-home-section-1-image', { transition: 0, opacity: 0, scale: 1.1 });
gsap.set('.co-home-section-1-content h1', { transition: 0, opacity: 0, x: 20 });
gsap.set('.co-home-section-1-button-1', { transition: 0, opacity: 0, x: 20 });
gsap.set('.co-home-section-1-button-2', { transition: 0, opacity: 0, x: 20 });
let coHomeSec1 = gsap.timeline();
coHomeSec1.to('.co-home-section-1-image', {
  scale: 1, opacity: 1, ease: "power2.inOut", duration: 0.75
});
coHomeSec1.to('.co-home-section-1-content h1', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 0.75
}, "-=0.5");
coHomeSec1.to('.co-home-section-1-button-1', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 0.75
}, "-=0.5");
coHomeSec1.to('.co-home-section-1-button-2', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 0.75
}, "-=0.5");
// SCROLL
gsap.set('.co-home-section-1-image img', { top: "0%", transition: 0 });
gsap.to('.co-home-section-1-image img', {
  scrollTrigger: {
    trigger: 'body', endTrigger: '.co-home-section-1', start:'top top', end: "bottom top", scrub: 1.05
  },
  top: "-10%",
  scale: 1.2
});
// ==================================================================================== SECTION 2
// NEXT PREV CLASSES
Flickity.createMethods.push('_createPrevNextCells');
Flickity.prototype._createPrevNextCells = function() {
  this.on( 'select', this.setPrevNextCells );
};
Flickity.prototype.setPrevNextCells = function() {
  changeSlideClasses( this.previousSlide, 'remove', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'remove', 'is-next' );
  var previousI = fizzyUIUtils.modulo( this.selectedIndex - 1, this.slides.length );
  var nextI = fizzyUIUtils.modulo( this.selectedIndex + 1, this.slides.length );
  this.previousSlide = this.slides[ previousI ];
  this.nextSlide = this.slides[ nextI ];
  changeSlideClasses( this.previousSlide, 'add', 'is-previous' );
  changeSlideClasses( this.nextSlide, 'add', 'is-next' );
};
function changeSlideClasses( slide, method, className ) {
  if ( !slide ) {
    return;
  }
  slide.getCellElements().forEach( function( cellElem ) {
    cellElem.classList[ method ]( className );
  });
}
// SLIDER
new Flickity( '.co-home-section-2-carousel', {
    cellAlign: "center", 
    contain: true, 
    prevNextButtons: true, 
    pageDots: false, 
    wrapAround: true, 
    // autoPlay: 3000,
    on: {
      ready: function() {
        // Set
        let co_home_sec_2_cell_1 = document.querySelector('.co-home-section-2 .carousel-cell.is-previous .co-home-section-2-carousel-img-2');
        let co_home_sec_2_cell_2_img = document.querySelector('.co-home-section-2 .carousel-cell.is-selected .co-home-section-2-carousel-img-1 > img');
        let co_home_sec_2_cell_2 = document.querySelector('.co-home-section-2 .carousel-cell.is-selected .co-home-section-2-carousel-img-2');
        let co_home_sec_2_cell_2_content = document.querySelector('.co-home-section-2 .carousel-cell.is-selected .co-home-section-2-carousel-content > div');
        let co_home_sec_2_cell_3 = document.querySelector('.co-home-section-2 .carousel-cell.is-next .co-home-section-2-carousel-img-2');
        gsap.set('.co-home-section-2', { transition: 0, opacity: 0 });
        gsap.set(co_home_sec_2_cell_1, { x: 50, transition: 0, opacity: 0 });
        gsap.set(co_home_sec_2_cell_2_img, { x: 50, transition: 0, opacity: 0 });
        gsap.set(co_home_sec_2_cell_2, { x: 50, transition: 0, opacity: 0 });
        gsap.set(co_home_sec_2_cell_2_content, { x: 50, transition: 0, opacity: 0 });
        gsap.set(co_home_sec_2_cell_3, { x: 50, transition: 0, opacity: 0 });
        // Timeline
        let co_home_sec_2_tl = gsap.timeline({ paused: true });
        // To
        co_home_sec_2_tl.to('.co-home-section-2', {
          opacity: 1, ease: "power2.inOut", duration: 1
        });
        co_home_sec_2_tl.to(co_home_sec_2_cell_1, {
          x: 0, opacity: 1, ease: "power2.inOut", duration: 1
        }, '-=0.95');
        co_home_sec_2_tl.to(co_home_sec_2_cell_2_img, {
          x: 0, opacity: 1, ease: "power2.inOut", duration: 1
        }, '-=0.75');
        co_home_sec_2_tl.to(co_home_sec_2_cell_2, {
          x: 0, opacity: 1, ease: "power2.inOut", duration: 1
        }, '-=0.95');
        co_home_sec_2_tl.to(co_home_sec_2_cell_2_content, {
          x: 0, opacity: 1, ease: "power2.inOut", duration: 1
        }, '-=0.95');
        co_home_sec_2_tl.to(co_home_sec_2_cell_3, {
          x: 0, opacity: 1, ease: "power2.inOut", duration: 1
        }, '-=0.75');
        // Trigger
        ScrollTrigger.create({
          // markers: true,
          trigger: '.co-home-section-2', start:'top bottom', end: "bottom bottom", animation: co_home_sec_2_tl
        });
      }
    }
  });
// ==================================================================================== GLOBAL 2
// Set
gsap.set('.co-global-section-2-left', { y: 20, transition: 0, opacity: 0 });
gsap.set('.co-global-section-2-right', { x: 10, transition: 0, opacity: 0 });
gsap.set('.co-global-section-2-right-wrapper', { y: 10, transition: 0, opacity: 0 });
// Timeline
let co_global_sec_2_tl = gsap.timeline({ paused: true });
// To
co_global_sec_2_tl.to('.co-global-section-2-left', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
});
co_global_sec_2_tl.to('.co-global-section-2-right', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, '-=0.75');
co_global_sec_2_tl.to('.co-global-section-2-right-wrapper', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, '-=0.95');
// Trigger
ScrollTrigger.create({
  // markers: true,
  trigger: '.co-global-section-2', start:'top bottom', end: "bottom bottom", animation: co_global_sec_2_tl
});
// SCROLL
gsap.set('.co-global-section-2-left-image', { top: "0%", transition: 0 });
gsap.to('.co-global-section-2-left-image', {
  scrollTrigger: {
    trigger: '.co-global-section-2-left', start:'top bottom', end: "bottom top", scrub: 1.25
  },
  top: "-10%"
});
// gsap.set('.co-global-section-2-right-image', { left: "0%", transition: 0 });
// gsap.to('.co-global-section-2-right-image', {
//   scrollTrigger: {
//     trigger: '.co-global-section-2-right', start:'top bottom', end: "bottom top", scrub: 1.25
//   },
//   left: "-5%"
// });
// ==================================================================================== SECTION 3
// Set
gsap.set('.co-home-section-3-ani-item', { x: 20, transition: 0, opacity: 0 });
gsap.set('.co-home-section-3 .video-section', { x: 20, transition: 0, opacity: 0 });
gsap.set('.co-home-section-3-hands-frame', { x: 20, transition: 0, opacity: 0 });
// Timeline
let co_home_sec_3_tl = gsap.timeline({ paused: true });
// To
co_home_sec_3_tl.to('.co-home-section-3 .video-section', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 1
});
co_home_sec_3_tl.to('.co-home-section-3-hands-frame', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, "-=0.85");
co_home_sec_3_tl.to('.co-home-section-3-ani-item', {
  x: 0, opacity: 1, ease: "power2.inOut", stagger: 0.15, duration: 1
}, "-=0.85");
// Trigger
ScrollTrigger.create({
  // markers: true,
  trigger: '.co-home-section-3-left', start:'top bottom', end: "bottom bottom", animation: co_home_sec_3_tl
});
// ==================================================================================== SECTION 4
// Set
gsap.set('.co-home-section-4-title h2', { x: 20, transition: 0, opacity: 0 });
gsap.set('.co-home-section-4-title-image', { y: -40, transition: 0, opacity: 0 });
gsap.set('.co-home-section-4-ani-item', { x: 20, transition: 0, opacity: 0 });
// Timeline
let co_home_sec_4_tl = gsap.timeline({ paused: true });
// To
co_home_sec_4_tl.to('.co-home-section-4-title h2', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 1
});
co_home_sec_4_tl.to('.co-home-section-4-title-image', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, "-=0.95");
co_home_sec_4_tl.to('.co-home-section-4-ani-item', {
  x: 0, opacity: 1, ease: "power2.inOut", stagger: 0.15, duration: 1
}, "-=0.95");
// Trigger
ScrollTrigger.create({
  // markers: true,
  trigger: '.co-home-section-4', start:'top bottom', end: "bottom bottom", animation: co_home_sec_4_tl
});
// ==================================================================================== SECTION 5
// Set
gsap.set('.co-home-section-5-left', { y: 20, transition: 0, opacity: 0 });
gsap.set('.co-home-section-5-right', { y: 20, transition: 0, opacity: 0 });
// Timeline
let co_home_sec_5_tl = gsap.timeline({ paused: true });
// To
co_home_sec_5_tl.to('.co-home-section-5-left', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
});
co_home_sec_5_tl.to('.co-home-section-5-right', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, "-=0.75");
// Trigger
ScrollTrigger.create({
  // markers: true,
  trigger: '.co-home-section-5', start:'top bottom', end: "bottom bottom", animation: co_home_sec_5_tl
});
// SCROLL
gsap.set('.co-home-section-5-left > img', { top: "-10%", transition: 0 });
gsap.to('.co-home-section-5-left > img', {
  scrollTrigger: {
    trigger: '.co-home-section-5-left', start:'top bottom', end: "bottom top", scrub: 1.25
  },
  top: "0%"
});
gsap.set('.co-home-section-5-right > img', { top: "0%", transition: 0 });
gsap.to('.co-home-section-5-right > img', {
  scrollTrigger: {
    trigger: '.co-home-section-5-right', start:'top bottom', end: "bottom top", scrub: 1.25
  },
  top: "-10%"
});
// ==================================================================================== SECTION 6
// TIMELINE
// Set
gsap.set('.co-home-section-6-frame', { transition: 0, opacity: 0 });
gsap.set('.co-home-section-6-ani-item', { y: 30, transition: 0 });
// Timeline
let co_home_sec_6_tl = gsap.timeline({ paused: true });
// To
co_home_sec_6_tl.to('.co-home-section-6-frame', {
  opacity: 1, ease: "power2.inOut", duration: 1
});
co_home_sec_6_tl.to('.co-home-section-6-ani-item', {
  y: 0, ease: "power2.inOut", stagger: 0.1, duration: 1
}, "-=1");
// Trigger
ScrollTrigger.create({
  trigger: '.co-home-section-6-frame', start:'top bottom', end: "bottom bottom", animation: co_home_sec_6_tl
});
// TOTRIGGER
gsap.set('.co-home-section-6-image', { y: 20, opacity: 0, transition: 0 });
gsap.to('.co-home-section-6-image', {
  scrollTrigger: {
    trigger: '.co-home-section-6-image', start:'top bottom', end: "bottom bottom"
  },
  opacity: 1, y: 0, ease: "power2.inOut", duration: 1
});
// SCROLL
gsap.set('.co-home-section-6-wave-top', { x: "0%", transition: 0 });
gsap.to('.co-home-section-6-wave-top', {
  scrollTrigger: {
    trigger: '.co-home-section-6-wave-top', start:'top bottom', end: "bottom top", scrub: 1.5
  },
  x: "-11%"
});
gsap.set('.co-home-section-6-wave-bottom', { x: "0%", transition: 0 });
gsap.to('.co-home-section-6-wave-bottom', {
  scrollTrigger: {
    trigger: '.co-home-section-6-wave-bottom', start:'top bottom', end: "bottom top", scrub: 1.5
  },
  x: "11%"
});
gsap.set('.co-home-section-6-image > img', { scale: 1, transition: 0 });
gsap.to('.co-home-section-6-image > img', {
  scrollTrigger: {
    trigger: '.co-home-section-6-image', start:'top bottom', end: "bottom top", scrub: 1.1
  },
  scale: 1.1
});

// ==================================================================================== GLOBAL 3
// Set
gsap.set('.co-global-section-3-right', { y: 20, transition: 0, opacity: 0 });
gsap.set('.co-global-section-3-left', { x: -10, transition: 0, opacity: 0 });
gsap.set('.co-global-section-3-left-wrapper', { y: 10, transition: 0, opacity: 0 });
// Timeline
let co_global_sec_3_tl = gsap.timeline({ paused: true });
// To
co_global_sec_3_tl.to('.co-global-section-3-left', {
  x: 0, opacity: 1, ease: "power2.inOut", duration: 1
});
co_global_sec_3_tl.to('.co-global-section-3-left-wrapper', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, '-=0.95');
co_global_sec_3_tl.to('.co-global-section-3-right', {
  y: 0, opacity: 1, ease: "power2.inOut", duration: 1
}, '-=0.75');
// Trigger
ScrollTrigger.create({
  trigger: '.co-global-section-3', start:'top bottom', end: "bottom bottom", animation: co_global_sec_3_tl
});
// SCROLL
gsap.set('.co-global-section-3-right-image', { top: "0%", transition: 0 });
gsap.to('.co-global-section-3-right-image', {
  scrollTrigger: {
    trigger: '.co-global-section-3-right', start:'top bottom', end: "bottom top", scrub: 1.25
  },
  top: "-10%"
});
// gsap.set('.co-global-section-3-left-image', { left: "-5%", transition: 0 });
// gsap.to('.co-global-section-3-left-image', {
//   scrollTrigger: {
//     trigger: '.co-global-section-3-left', start:'top bottom', end: "bottom top", scrub: 1.25
//   },
//   left: "0%"
// });
